// src/features/auth/login/ui/LoginPage.tsx
'use client';

import { FormProvider } from 'react-hook-form';
import { FC } from 'react';
import { useLoginForm } from '../model/useLoginForm';
import { useTranslation } from 'react-i18next';

import TextInput from '@/entities/form/ui-tailwind/InputText';
import { Button } from '@/shared/ui-kit/src';

const LoginPage: FC = () => {
  const { t } = useTranslation();
  const { form, onSubmit, isBusy, isSubmitting, isRedirecting } = useLoginForm();

  return (
    <div className='w-full min-w-0 flex flex-col gap-8 box-border p-0 m-0'>
      {/* Título + texto */}
      <div className='flex flex-col items-center gap-3 text-center'>
        <h1 className='m-0 text-2xl md:text-3xl font-semibold tracking-tight text-[var(--Gray-950)]'>{t('auth.login.title')}</h1>
        <p className='m-0 text-sm md:text-base text-[var(--Gray-600)]'>{t('auth.login.text')}</p>
      </div>
      <FormProvider {...form}>
        <form onSubmit={onSubmit} className='contents'>
          <div className='flex flex-col gap-8 w-full'>
            <div className='flex flex-col gap-4 w-full'>
              <TextInput name='email' label={t('common.email')} placeholder={t('common.email')} disabled={isBusy} wrapperClassName='w-full' />
              <TextInput isPassword name='password' label={t('common.password')} placeholder={t('common.password')} type='password' disabled={isBusy} wrapperClassName='w-full' />
            </div>

            <Button
              size='large'
              loading={isSubmitting || isRedirecting}
              disabled={!form.formState.isValid || isBusy}
              className='w-full
                bg-[rgb(55,55,55)] 
                hover:bg-[rgb(55,55,55)]/90 
                text-white 
                border-0
                focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/20
                disabled:opacity-80 disabled:bg-[rgb(55,55,55)]'
            >
              {isRedirecting ? t('common.redirecting') : t('common.login')}
            </Button>
          </div>
        </form>
      </FormProvider>
    </div>
  );
};

export default LoginPage;
